import '@wix/wix-angular';
import angular from 'angular';
import { ExperimentLoaderController } from './ExperimentLoader.controller';
import template from './ExperimentLoader.template.html';

export const experimentLoaderModule = angular
  .module('bit.components.ExperimentLoader', ['wixAngular'])
  .component('bitExperimentLoader', {
    transclude: true,
    template,
    controller: ExperimentLoaderController,
  });
